import * as i0 from '@angular/core';
import { NgModule, Injectable } from '@angular/core';
import { startRegistration, startAuthentication } from '@simplewebauthn/browser';
import { firstValueFrom } from 'rxjs';
import * as i1 from '@angular/common/http';

class NgxAuthModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.4", ngImport: i0, type: NgxAuthModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "18.0.4", ngImport: i0, type: NgxAuthModule }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "18.0.4", ngImport: i0, type: NgxAuthModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.4", ngImport: i0, type: NgxAuthModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [],
                    imports: [],
                    exports: []
                }]
        }] });

class NgxAuthService {
    constructor(http) {
        this.http = http;
    }
    async registerPasskey() {
        const opts = await firstValueFrom(this.http.get("/api/auth/passkey/generateReg"));
        console.log(opts);
        let registrationResponse;
        try {
            registrationResponse = await startRegistration(opts);
        }
        catch (error) {
            console.log(error);
            if (error.name === 'InvalidStateError') {
                return { status: "alreadyregistered" };
            }
            else {
                return { status: "error" };
            }
        }
        const verificationRes = await firstValueFrom(this.http.post("/api/auth/passkey/verifyReg", registrationResponse));
        if (verificationRes?.verified) {
            return { status: "ok" };
        }
        else {
            return { status: "error" };
        }
    }
    async authenticatePasskey(email) {
        const res = await firstValueFrom(this.http.post("/api/auth/passkey/generateAuth", { email: email.toLowerCase() }));
        if (res.allowCredentials == undefined || res.allowCredentials?.length == 0) {
            return { status: "nopasskeyfound" };
        }
        let authenticationResponse;
        try {
            authenticationResponse = await startAuthentication(res);
        }
        catch (error) {
            return { status: "error" };
        }
        const verificationRes = await firstValueFrom(this.http.post("/api/auth/passkey/verifyAuth", { email: email.toLowerCase(), payload: authenticationResponse }));
        ;
        if (verificationRes?.verified) {
            return { status: "ok", token: verificationRes.token };
        }
        else {
            return { status: "error" };
        }
    }
    async getCurrentPasskeys() {
        return await firstValueFrom(this.http.post("/api/auth/passkey/getPasskeys", {}));
    }
    async logout() {
        return await firstValueFrom(this.http.post("/api/auth/logout", {}));
    }
    async generateEmailCode(email) {
        return await firstValueFrom(this.http.post('/api/auth/email/generateCodeForEmail', { email: email.toLowerCase() }));
    }
    async authenticateEmailCode(email, code) {
        const req = { email: email.toLowerCase(), verificationCode: code };
        return await firstValueFrom(this.http.post('/api/auth/email/loginWithEmailAndCode', req));
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "18.0.4", ngImport: i0, type: NgxAuthService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "18.0.4", ngImport: i0, type: NgxAuthService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "18.0.4", ngImport: i0, type: NgxAuthService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: () => [{ type: i1.HttpClient }] });

/*
 * Public API Surface of ngx-auth
 */

/**
 * Generated bundle index. Do not edit.
 */

export { NgxAuthModule, NgxAuthService };
